var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 703.6900098916262,
    height: 504.1957595907272,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "title%20%22%22%0A%0AFIU-%3EFinsense%3AInitiate%20a%20consent%20request%20for%20the%20customer%0Anote%20over%20FIU%2C%20Finsense%3A%20Customer%20completes%20the%20consent%20request%0A%0Anote%20over%20Finsense%3A%20Once%20data%20is%20ready%0AFinsense-%3ERiskGauge%3A%20Fetches%20data%20and%20performs%20analysis%0A%0ARiskGauge-%3EFIU%3A%20notifies%20of%20availability%20of%20data%0A%0AFIU-%3ERiskGauge%3A%20Fetch%20report%20in%20excel%20%2F%20json%20format")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    x: 0,
    y: 0,
    width: 703,
    height: 504
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 39.69038481982031 103.10369087072726 L 39.69038481982031 504.1957595907272",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: "13.532121076923076,5.863919133333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 360.4026259480104 103.10369087072726 L 360.4026259480104 504.1957595907272",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: "13.532121076923076,5.863919133333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 639.5472401230754 103.10369087072726 L 639.5472401230754 504.1957595907272",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: "13.532121076923076,5.863919133333333"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 8.7958787 55.60594589072727 L 70.58489093964062 55.60594589072727 L 70.58489093964062 103.10369087072726 L 8.7958787 103.10369087072726 L 8.7958787 55.60594589072727 Z",
    strokeMiterlimit: 10,
    strokeWidth: 2.814681184,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 27.882935478999997,
    y: 85.51193347072726,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "FIU")), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 311.5732748574869 55.60594589072727 L 409.2319770385338 55.60594589072727 L 409.2319770385338 103.10369087072726 L 311.5732748574869 103.10369087072726 L 311.5732748574869 55.60594589072727 Z",
    strokeMiterlimit: 10,
    strokeWidth: 2.814681184,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 330.66033163648694,
    y: 85.51193347072726,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "Finsense")), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 584.2003490545246 55.60594589072727 L 694.8941311916262 55.60594589072727 L 694.8941311916262 103.10369087072726 L 584.2003490545246 103.10369087072726 L 584.2003490545246 55.60594589072727 Z",
    strokeMiterlimit: 10,
    strokeWidth: 2.814681184,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 603.2874058335246,
    y: 85.51193347072726,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "RiskGauge"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    x: 60.507297743153615,
    y: 138.28720567072727,
    width: 279.0784305403125,
    height: 22.86928462
  }), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 63.14606135315361,
    y: 154.1197873307273,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "Initiate\xA0a\xA0consent\xA0request\xA0for\xA0the\xA0customer")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 39.69038481982031 161.15649029072728 L 345.91874568867706 161.15649029072728",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360.4026259480104,161.15649029072728) translate(-360.4026259480104,-161.15649029072728)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 345.742828114677 153.8265913740606 L 360.4026259480104 161.15649029072728 L 345.742828114677 168.48638920739396 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 23.85780315982031 187.54412639072729 L 360.4026259480103 187.54412639072729 L 376.23520760801034 203.37670805072727 L 376.23520760801034 228.00516841072726 L 23.85780315982031 228.00516841072726 L 23.85780315982031 187.54412639072729 M 360.4026259480103 187.54412639072729 L 360.4026259480103 203.37670805072727 L 376.23520760801034 203.37670805072727",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 66.41019099182549,
    y: 212.1725867507273,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "Customer\xA0completes\xA0the\xA0consent\xA0request")), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 274.2494921260963 254.39280451072727 L 430.7231781099244 254.39280451072727 L 446.5557597699244 270.2253861707273 L 446.5557597699244 294.85384653072725 L 274.2494921260963 294.85384653072725 L 274.2494921260963 254.39280451072727 M 430.7231781099244 254.39280451072727 L 430.7231781099244 270.2253861707273 L 446.5557597699244 270.2253861707273",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 298.8779524860963,
    y: 279.02126487072724,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "Once\xA0data\xA0is\xA0ready")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    x: 381.2195388713437,
    y: 321.24148263072726,
    width: 237.51078832839843,
    height: 22.86928462
  }), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 383.8583024813437,
    y: 337.0740642907273,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "Fetches\xA0data\xA0and\xA0performs\xA0analysis")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 360.4026259480104 344.11076725072724 L 625.0633598637421 344.11076725072724",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(639.5472401230754,344.11076725072724) translate(-639.5472401230754,-344.11076725072724)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 624.8874422897421 336.7808683340606 L 639.5472401230754 344.11076725072724 L 624.8874422897421 351.4406661673939 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    x: 245.30149814123303,
    y: 370.49840335072724,
    width: 188.63462866042968,
    height: 22.86928462
  }), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 247.94026175123304,
    y: 386.33098501072726,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "notifies\xA0of\xA0availability\xA0of\xA0data")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 639.5472401230754 393.3676879707272 L 54.17426507915364 393.3676879707272",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.69038481982031,393.3676879707272) translate(-39.69038481982031,-393.3676879707272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 54.35018265315364 386.03778905406057 L 39.69038481982031 393.3676879707272 L 54.35018265315364 400.69758688739387 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    x: 228.20772525304943,
    y: 419.7553240707272,
    width: 222.82217443679687,
    height: 22.86928462
  }), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    stroke: "none",
    fontFamily: "sans-serif",
    fontSize: "11pt",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 230.84648886304944,
    y: 435.58790573072724,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    xmlSpace: "preserve"
  }, "Fetch\xA0report\xA0in\xA0excel\xA0/\xA0json\xA0format")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    paintOrder: "fill stroke markers",
    d: " M 39.69038481982031 442.6246086907272 L 625.0633598637421 442.6246086907272",
    strokeMiterlimit: 10,
    strokeWidth: 1.4659797833333332,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(639.5472401230754,442.6246086907272) translate(-639.5472401230754,-442.6246086907272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 624.8874422897421 435.29470977406055 L 639.5472401230754 442.6246086907272 L 624.8874422897421 449.95450760739385 Z"
  })))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskguage);
export default __webpack_public_path__ + "static/media/riskguage.a3220bb1142369d77a8b83e892cbda4e.svg";
export { ForwardRef as ReactComponent };